export default {
  lang: "Lang",
  start: "Start",
  end: "End",
  download: "Download",
  reset: "Reset",
  downloadFile: "Download File",
  close: "Close",
  downloadDocument: "View Operation Manual",
  downloadProgress: "Download Process",
  rightClickPreview: "Right Click Preview",
  downloadTips: 'Files are being downloaded. Please wait while the download completes. You can view the progress of each file below. The files will be saved automatically when the download is complete.',
  // Map Controls
  undo: "Undo",
  redo: "Redo",
  toggleMapType: "Toggle Map Type",
  fullscreen: "Fullscreen",
  exitFullscreen: "Exit Fullscreen",
  
  // Point Selection
  selectStartPoint: "Select Start Point",
  selectEndPoint: "Select End Point",
  pointInfo: "Point Information",
  startPointInfo: "Start Point Info",
  endPointInfo: "End Point Info",
  time: "Time",
  longitude: "Longitude",
  latitude: "Latitude",
  deleteStartPoint: "Delete Start Point",
  deleteEndPoint: "Delete End Point",
  confirmDeleteStart: "Are you sure to delete the start point?",
  confirmDeleteEnd: "Are you sure to delete the end point?",
  pointDeleted: "Point deleted",
  startPointDeleted: "Start point deleted",
  endPointDeleted: "End point deleted",
  
  // Operation Tips
  clickToSelect: "Click to select this point",
  confirmRange: "Are you sure to select this range?",
  cancel: "Cancel",
  confirm: "Confirm",
  
  // Map Messages
  mapLoaded: "Map loaded successfully",
  browserNotSupported: "Please use Chrome, Safari, or IE8+ to view this example",
  
  // File Point Filter Modal
  filePointFilterTitle: "Please select the rosbag package folders you want to mark",
  selectAll: "Select All",
  deselectAll: "Deselect All",
  
  // Message Notifications
  operationUndone: "Operation undone",
  operationRedone: "Operation redone",
  selectionCancelled: "Selection cancelled",
  newStartPointSelected: "New start point selected",
  endPointSelected: "End point selected",
  
  // File Download Messages
  downloadError: "Download failed",
  downloadSuccess: "Download completed successfully",
  replicatingSuccess: "Copy successful",
  cancelAll: "Cancel All",
  downloadCancelled: "Download Cancelled",
  downloadCompleted: "Download Completed",
  downloadFailed: "Download Failed"
}